import {AOsApi} from '@/classes/app/api/os/a-os-api';
import ApiExecuterAsync from '@/classes/core/api/api-executer-async';
import ApiExecuterFactory from '@/classes/core/api/api-executer-factory';
import {ApiMethod} from '@/classes/core/api/api-method';
import VarUtil from '@/classes/utils/var-util';

export class Staff extends AOsApi {
    protected _url: string = '/staff';
}
